import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-b6969a06")

_pushScopeId("data-v-b6969a06")
const _hoisted_1 = { class: "flex flex-col w-full bg-white" }
const _hoisted_2 = { class: "flex flex-row items-center justify-between px-3 py-3 border-b border-gray-lp-400" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4 h-4",
  alt: "back"
}, null, -1)
const _hoisted_5 = { class: "text-16px xxl:text-18px font-semibold text-black-lp-300 text-" }
const _hoisted_6 = { class: " flex flex-row justify-between items-center gap-3 px-2 py-3" }
const _hoisted_7 = { class: "w-full flex flex-row items-center gap-3" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = { class: "w-3/4" }
const _hoisted_10 = { class: " w-76 flex flex-row justify-end gap-3" }
const _hoisted_11 = { class: "px-3 py-3 border-b border-gray-lp-400  gap-4" }
const _hoisted_12 = { class: "w-full flex flex-row justify-between" }
const _hoisted_13 = {
  key: 0,
  class: "text-14px text-black-lp-300 w-full"
}
const _hoisted_14 = { class: "w-full flex flex-col items-end" }
const _hoisted_15 = { class: "ml-2" }
const _hoisted_16 = { class: "flex-1 overflow-x-auto" }
const _hoisted_17 = {
  key: 0,
  class: "flex justify-center items-center h-64"
}
const _hoisted_18 = {
  key: 1,
  class: "px-4 py-6"
}
const _hoisted_19 = {
  key: 2,
  class: "overflow-x-auto",
  style: {"height":"70vh"}
}
const _hoisted_20 = { class: "w-full border-collapse table-fixed" }
const _hoisted_21 = { class: "border-b border-gray-300 sticky top-0 bg-white z-10" }
const _hoisted_22 = { class: "px-3 py-4 text-left w-8" }
const _hoisted_23 = { class: "px-3 py-4 text-left text-sm font-bold text-gray-lp-300 w-10" }
const _hoisted_24 = { class: "flex items-center gap-2" }
const _hoisted_25 = { class: "px-3 py-4 text-left text-sm font-bold text-gray-lp-300 w-36" }
const _hoisted_26 = { class: "flex items-center gap-1" }
const _hoisted_27 = { class: "whitespace-nowrap" }
const _hoisted_28 = { class: "flex items-center gap-2" }
const _hoisted_29 = { class: "px-3 py-4 text-left text-sm font-bold text-gray-lp-300 w-50" }
const _hoisted_30 = { class: "px-2 py-4 text-center text-sm font-bold text-gray-lp-300 w-16" }
const _hoisted_31 = { class: "text-xs leading-tight" }
const _hoisted_32 = { class: "bg-white" }
const _hoisted_33 = { class: "px-3 py-3" }
const _hoisted_34 = { class: "px-3 py-3 text-sm font-medium text-gray-lp-300" }
const _hoisted_35 = { class: "px-3 py-3" }
const _hoisted_36 = { class: "text-sm font-semibold text-gray-lp-300 mb-1 line-clamp-2" }
const _hoisted_37 = { class: "text-sm text-gray-lp-600 flex items-center gap-2" }
const _hoisted_38 = { class: "truncate" }
const _hoisted_39 = { class: "px-3 py-3 text-sm text-gray-lp-300" }
const _hoisted_40 = { class: "truncate block" }
const _hoisted_41 = { class: "px-3 py-3 text-sm font-medium text-gray-lp-300" }
const _hoisted_42 = { class: "whitespace-nowrap" }
const _hoisted_43 = { class: "px-3 py-3 text-sm font-medium" }
const _hoisted_44 = { class: "px-3 py-3 text-sm" }
const _hoisted_45 = { class: "px-2 py-3 text-center" }
const _hoisted_46 = { class: "px-3 py-3 border-t border-gray-200" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_DateRangePicker = _resolveComponent("DateRangePicker")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_DownloadWithDateRange = _resolveComponent("DownloadWithDateRange")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_TableLazyLoad = _resolveComponent("TableLazyLoad")!
  const _component_EmptyList = _resolveComponent("EmptyList")!
  const _component_PaginationV3 = _resolveComponent("PaginationV3")!
  const _component_TransferPickupModal = _resolveComponent("TransferPickupModal")!
  const _component_WidgetDownload = _resolveComponent("WidgetDownload")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("button", {
            class: "w-8 h-8 rounded-full flex items-center justify-center",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, [
            _hoisted_4
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("span", {
              innerHTML: 
              _ctx.headerTitle.replace(
                /•/g,
                '<span class=\'text-gray-lp-1300\'>•</span>'
              )
            
            }, null, 8, ["innerHTML"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_Search, {
            onEnter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSearchInput($event.target.value))),
            onClear: _ctx.onClearSearch,
            value: _ctx.searchKeyword,
            placeholder: _ctx.$t('pickupDashboard.searchPlaceholder'),
            isIconLeft: "",
            isIconClearRight: "",
            timeout: 300,
            minChar: 1,
            class: "w-full"
          }, null, 8, ["onClear", "value", "placeholder"]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_DateRangePicker, {
              modelValue: _ctx.dateRangeValue,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dateRangeValue = $event)),
              onApply: _ctx.onDateRangeApply,
              onReset: _ctx.onDateRangeReset,
              defaultPreset: 0,
              maxRange: 31,
              placeholder: _ctx.$t('pickupDashboard.allTime')
            }, null, 8, ["modelValue", "onApply", "onReset", "placeholder"])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_MultipleSelectSearch, {
              placeholder: _ctx.$t('pickupDashboard.shipmentType'),
              options: _ctx.shipmentTypes,
              modelValue: _ctx.selectedShipmentTypes,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedShipmentTypes = $event)),
              keyName: "name",
              keyValue: "value",
              showSelected: false,
              showSelectedInInput: "",
              isSearchReadonly: "",
              onChange: _ctx.onShipmentTypeChange
            }, null, 8, ["placeholder", "options", "modelValue", "onChange"])
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_DownloadWithDateRange, {
            buttonText: _ctx.$t('pickupDashboard.downloadDataPickUp'),
            onDownload: _ctx.handleDownloadDataPickup
          }, null, 8, ["buttonText", "onDownload"])
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          (_ctx.selectedSellers.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_13, _toDisplayString(_ctx.selectedCount) + " " + _toDisplayString(_ctx.$t("pickupDashboard.selectedSender")), 1))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_14, [
            (_ctx.selectedSellers.length > 0)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: "flex items-center text-sm bg-red-lp-100 text-white px-4 py-2 rounded-md font-semibold",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openTransferModal && _ctx.openTransferModal(...args))),
                  disabled: _ctx.selectedSellers.length === 0
                }, [
                  _createVNode(_component_Icons, { name: "sort-transfer-pickup-white" }),
                  _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("pickupDashboard.transferPickUp")), 1)
                ], 8, ["disabled"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_16, [
        (_ctx.isLoadingSenderList)
          ? (_openBlock(), _createBlock("div", _hoisted_17, [
              _createVNode(_component_TableLazyLoad, { columns: _ctx.columns }, null, 8, ["columns"])
            ]))
          : (_ctx.senderList.data.length === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_18, [
                (_ctx.hasSearchOrFilter)
                  ? (_openBlock(), _createBlock(_component_EmptyList, {
                      key: 0,
                      icon: "ill_spot_search",
                      customHeaderMessage: _ctx.$t('pickupDashboard.emptyState.searchNotFound'),
                      customMessage: _ctx.$t('pickupDashboard.emptyState.searchNotFoundHint')
                    }, null, 8, ["customHeaderMessage", "customMessage"]))
                  : (_openBlock(), _createBlock(_component_EmptyList, {
                      key: 1,
                      data: "data",
                      customHeaderMessage: _ctx.$t('pickupDashboard.emptyState.noPackage'),
                      customMessage: _ctx.$t('pickupDashboard.emptyState.noPackageHint')
                    }, null, 8, ["customHeaderMessage", "customMessage"]))
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_19, [
                _createVNode("table", _hoisted_20, [
                  _createVNode("thead", _hoisted_21, [
                    _createVNode("tr", null, [
                      _createVNode("th", _hoisted_22, [
                        _createVNode("input", {
                          type: "checkbox",
                          checked: 
                    _ctx.selectedCount === _ctx.senderList.data.length &&
                      _ctx.senderList.data.length > 0
                  ,
                          onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleAllSenders && _ctx.toggleAllSenders(...args))),
                          class: "w-5 h-5 rounded border-2 border-gray-400 text-red-lp-100 focus:ring-red-lp-100 focus:ring-2 checked:bg-red-lp-100 checked:border-red-lp-100",
                          style: {"accent-color":"#B82025"}
                        }, null, 40, ["checked"])
                      ]),
                      _createVNode("th", _hoisted_23, _toDisplayString(_ctx.$t("pickupDashboard.column.no")), 1),
                      _createVNode("th", {
                        class: "px-3 py-4 text-left text-sm font-bold text-gray-lp-300 cursor-pointer hover:bg-gray-200 transition-colors w-44",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sortBy('sender_name')))
                      }, [
                        _createVNode("div", _hoisted_24, [
                          _createTextVNode(_toDisplayString(_ctx.$t("pickupDashboard.column.senderName")) + " ", 1),
                          (
                      _ctx.currentSort !== 'sender_name' || _ctx.currentSortOrder === ''
                    )
                            ? (_openBlock(), _createBlock(_component_Icons, {
                                key: 0,
                                name: "sort-transfer-pickup",
                                class: "w-4 h-4 opacity-50"
                              }))
                            : (_ctx.currentSortOrder === 'DESC')
                              ? (_openBlock(), _createBlock("img", {
                                  key: 1,
                                  src: 
                      require('@/app/ui/assets/svg/ics_o_chevron_sort_desc.svg')
                    ,
                                  class: "w-4 h-4"
                                }, null, 8, ["src"]))
                              : (_ctx.currentSortOrder === 'ASC')
                                ? (_openBlock(), _createBlock("img", {
                                    key: 2,
                                    src: 
                      require('@/app/ui/assets/svg/ics_o_chevron_sort_asc.svg')
                    ,
                                    class: "w-4 h-4"
                                  }, null, 8, ["src"]))
                                : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("th", _hoisted_25, _toDisplayString(_ctx.$t("pickupDashboard.column.shipmentType")), 1),
                      _createVNode("th", {
                        class: "px-3 py-4 text-left text-sm font-bold text-gray-lp-300 cursor-pointer hover:bg-gray-200 transition-colors w-36",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sortBy('total_shipment')))
                      }, [
                        _createVNode("div", _hoisted_26, [
                          _createVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("pickupDashboard.column.totalShipment")), 1),
                          (
                      _ctx.currentSort !== 'total_shipment' ||
                        _ctx.currentSortOrder === ''
                    )
                            ? (_openBlock(), _createBlock(_component_Icons, {
                                key: 0,
                                name: "sort-transfer-pickup",
                                class: "w-4 h-4 opacity-50"
                              }))
                            : (_ctx.currentSortOrder === 'DESC')
                              ? (_openBlock(), _createBlock("img", {
                                  key: 1,
                                  src: 
                      require('@/app/ui/assets/svg/ics_o_chevron_sort_desc.svg')
                    ,
                                  class: "w-4 h-4"
                                }, null, 8, ["src"]))
                              : (_ctx.currentSortOrder === 'ASC')
                                ? (_openBlock(), _createBlock("img", {
                                    key: 2,
                                    src: 
                      require('@/app/ui/assets/svg/ics_o_chevron_sort_asc.svg')
                    ,
                                    class: "w-4 h-4"
                                  }, null, 8, ["src"]))
                                : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("th", {
                        class: "px-3 py-4 text-left text-sm font-bold text-gray-lp-300 cursor-pointer hover:bg-gray-200 transition-colors w-28",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sortBy('expired_at')))
                      }, [
                        _createVNode("div", _hoisted_28, [
                          _createTextVNode(_toDisplayString(_ctx.$t("pickupDashboard.column.remainingTime")) + " ", 1),
                          (
                      _ctx.currentSort !== 'expired_at' || _ctx.currentSortOrder === ''
                    )
                            ? (_openBlock(), _createBlock(_component_Icons, {
                                key: 0,
                                name: "sort-transfer-pickup",
                                class: "w-4 h-4 opacity-50"
                              }))
                            : (_ctx.currentSortOrder === 'DESC')
                              ? (_openBlock(), _createBlock("img", {
                                  key: 1,
                                  src: 
                      require('@/app/ui/assets/svg/ics_o_chevron_sort_desc.svg')
                    ,
                                  class: "w-4 h-4"
                                }, null, 8, ["src"]))
                              : (_ctx.currentSortOrder === 'ASC')
                                ? (_openBlock(), _createBlock("img", {
                                    key: 2,
                                    src: 
                      require('@/app/ui/assets/svg/ics_o_chevron_sort_asc.svg')
                    ,
                                    class: "w-4 h-4"
                                  }, null, 8, ["src"]))
                                : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("th", _hoisted_29, _toDisplayString(_ctx.$t("pickupDashboard.column.address")), 1),
                      _createVNode("th", _hoisted_30, [
                        _createVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("pickupDashboard.column.transferPickUp")), 1)
                      ])
                    ])
                  ]),
                  _createVNode("tbody", _hoisted_32, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.senderList.data, (sender, index) => {
                      return (_openBlock(), _createBlock("tr", {
                        key: `${sender.id}-${index}`,
                        class: "border-b border-gray-200 hover:bg-gray-50 transition-colors"
                      }, [
                        _createVNode("td", _hoisted_33, [
                          _createVNode("input", {
                            type: "checkbox",
                            checked: _ctx.isSenderSelected(sender, index),
                            onChange: ($event: any) => (_ctx.toggleSenderSelection(sender, index)),
                            class: "w-5 h-5 rounded border-2 border-gray-400 text-red-lp-100 focus:ring-red-lp-100 focus:ring-2 checked:bg-red-lp-100 checked:border-red-lp-100",
                            style: {"accent-color":"#B82025"}
                          }, null, 40, ["checked", "onChange"])
                        ]),
                        _createVNode("td", _hoisted_34, _toDisplayString((_ctx.currentPage - 1) * _ctx.paginationObject.limit + index + 1), 1),
                        _createVNode("td", _hoisted_35, [
                          _createVNode("div", _hoisted_36, _toDisplayString(sender.senderName), 1),
                          _createVNode("div", _hoisted_37, [
                            _createVNode("span", _hoisted_38, _toDisplayString(_ctx.formatPhoneNumber(sender.senderPhone)), 1),
                            _createVNode("a", {
                              href: `https://wa.me/${_ctx.waNumber(sender.senderPhone)}`,
                              target: "_blank",
                              class: "text-green-500 hover:text-green-600 transition-colors flex-shrink-0"
                            }, [
                              _createVNode(_component_Icons, {
                                name: "whatsapp",
                                class: "w-4 h-4"
                              })
                            ], 8, ["href"])
                          ])
                        ]),
                        _createVNode("td", _hoisted_39, [
                          _createVNode("span", _hoisted_40, _toDisplayString(_ctx.getShipmentTypeLabel(sender.shipmentType)), 1)
                        ]),
                        _createVNode("td", _hoisted_41, [
                          _createVNode("span", _hoisted_42, _toDisplayString(_ctx.fmtQty(sender.totalShipment)) + " (" + _toDisplayString(_ctx.fmtQty(sender.totalQuantity)) + ")", 1)
                        ]),
                        _createVNode("td", _hoisted_43, [
                          _createVNode("div", {
                            class: 
                    _ctx.formatCountdown(sender.expiredAt).isUrgent
                      ? 'text-red-lp-2000 bg-red-lp-1300 rounded px-2 py-1 text-center inline-block min-w-20'
                      : 'text-gray-lp-300 bg-gray-lp-1000 rounded px-2 py-1 text-center inline-block min-w-20'
                  
                          }, _toDisplayString(_ctx.formatCountdown(sender.expiredAt).display), 3)
                        ]),
                        _createVNode("td", _hoisted_44, [
                          _createVNode("a", {
                            href: _ctx.getGoogleMapsUrl(sender),
                            target: "_blank",
                            class: "text-red-lp-100 hover:text-red-lp-100 hover:underline line-clamp-2 transition-colors block",
                            title: sender.senderAddress
                          }, _toDisplayString(sender.senderAddress), 9, ["href", "title"])
                        ]),
                        _createVNode("td", _hoisted_45, [
                          _createVNode("button", {
                            onClick: ($event: any) => (_ctx.openSingleTransferModal(sender)),
                            class: "p-1.5 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors",
                            title: "Transfer Pick Up"
                          }, [
                            _createVNode(_component_Icons, {
                              name: "transfer-pickup",
                              class: "w-4 h-4"
                            })
                          ], 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
      ]),
      _createVNode("div", _hoisted_46, [
        _createVNode(_component_PaginationV3, {
          pagination: _ctx.paginationObject,
          renderedData: _ctx.senderList.data.length,
          onSetPage: _ctx.onPageChange
        }, null, 8, ["pagination", "renderedData", "onSetPage"])
      ]),
      _createVNode(_component_TransferPickupModal, {
        show: _ctx.showTransferModal,
        selectedSellers: _ctx.selectedSellers,
        sourceCourierId: parseInt(_ctx.courierId),
        "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => (_ctx.showTransferModal = $event)),
        onRemoveSeller: _ctx.handleRemoveSeller,
        onTransferSuccess: _ctx.handleTransferSuccess
      }, null, 8, ["show", "selectedSellers", "sourceCourierId", "onRemoveSeller", "onTransferSuccess"])
    ]),
    _createVNode(_component_WidgetDownload)
  ], 64))
})